export default __webpack_public_path__ + "static/media/df026b574aa41cf456071ab8f725f225.93092f61.png";